import React from 'react';

import { ListItemButton, ListItemText, Stack, Typography } from '@mui/material';

import RoleChip from 'components/chip/RoleChip';
import { UserResult } from 'stores/UserStoreAdapter';

type UserListItemProps = {
  user: UserResult;
  onClick?: () => void;
};

/**
 * ConditionListPanel の renderItem 内で使用する場合は onClick を省略する。
 * 単独で使用する場合は onClick を渡して ListItemButton でラップされる。
 */
const UserListItem: React.FC<UserListItemProps> = ({ user, onClick }) => {
  const content = (
    <ListItemText
      primary={
        <Stack direction="row" alignItems="center" justifyContent="space-between" component="span">
          <Typography
            variant="body2"
            fontWeight={500}
            noWrap
            component="span"
            sx={{ flex: 1, minWidth: 0 }}
          >
            {user.userName}
          </Typography>
          <Stack direction="row" spacing={0.5} sx={{ ml: 1, flexShrink: 0 }}>
            {user.roles.map((role) => (
              <RoleChip key={role} role={role} size="small" variant="filled" />
            ))}
          </Stack>
        </Stack>
      }
      secondary={
        <Typography variant="caption" color="text.secondary" component="span">
          {user.mailAddress}
        </Typography>
      }
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    />
  );

  if (onClick) {
    return (
      <ListItemButton divider onClick={onClick}>
        {content}
      </ListItemButton>
    );
  }

  return content;
};

export default UserListItem;
